export const supportedResourcesDescription = [
    {
        "Type": "AllergyIntolerance",
        "Description": "Risk of harmful or undesirable physiological response which is specific to an individual and associated with exposure to a substance.",
        "URL": "https://hl7.org/fhir/AllergyIntolerance.html"
    },
    {
        "Type": "Basic",
        "Description": "Basic is used for handling concepts not yet defined in FHIR, narrative-only resources that don't map to an existing resource, and custom resources not appropriate for inclusion in the FHIR specification.",
        "URL": "https://hl7.org/fhir/Basic.html"
    },
    {
        "Type": "Binary",
        "Description": "A resource that represents the data of a single raw artifact as digital content accessible in its native format. A Binary resource can contain any content, whether text, image, pdf, zip archive, etc.",
        "URL": "https://hl7.org/fhir/Binary.html"
    },
    {
        "Type": "CarePlan",
        "Description": "Describes the intention of how one or more practitioners intend to deliver care for a particular patient, group or community for a period of time, possibly limited to care for a specific condition or set of conditions.",
        "URL": "https://hl7.org/fhir/CarePlan.html"
    },
    {
        "Type": "CareTeam",
        "Description": "The Care Team includes all the people and organizations who plan to participate in the coordination and delivery of care.",
        "URL": "https://hl7.org/fhir/CareTeam.html"
    },
    {
        "Type": "Claim",
        "Description": "A provider issued list of professional services and products which have been provided, or are to be provided, to a patient which is sent to an insurer for reimbursement.",
        "URL": "https://hl7.org/fhir/Claim.html"
    },
    {
        "Type": "ClaimResponse",
        "Description": "This resource provides the adjudication details from the processing of a Claim resource.",
        "URL": "https://hl7.org/fhir/ClaimResponse.html"
    },
    {
        "Type": "Condition",
        "Description": "A clinical condition, problem, diagnosis, or other event, situation, issue, or clinical concept that has risen to a level of concern.",
        "URL": "https://hl7.org/fhir/Condition.html"
    },
    {
        "Type": "Coverage",
        "Description": "Financial instrument which may be used to reimburse or pay for health care products and services. Includes both insurance and self-payment.",
        "URL": "https://hl7.org/fhir/Coverage.html"
    },
    {
        "Type": "Device",
        "Description": "A type of a manufactured item that is used in the provision of healthcare without being substantially changed through that activity. The device may be a medical or non-medical device.",
        "URL": "https://hl7.org/fhir/Device.html"
    },
    {
        "Type": "DiagnosticReport",
        "Description": "The findings and interpretation of diagnostic tests performed on patients, groups of patients, products, substances, devices, and locations, and/or specimens derived from these. The report includes clinical context such as requesting provider information, and some mix of atomic results, images, textual and coded interpretations, and formatted representation of diagnostic reports. The report also includes non-clinical context such as batch analysis and stability reporting of products and substances.",
        "URL": "https://hl7.org/fhir/DiagnosticReport.html"
    },
    {
        "Type": "DocumentReference",
        "Description": "A reference to a document of any kind for any purpose. While the term \u201cdocument\u201d implies a more narrow focus, for this resource this \"document\" encompasses any serialized object with a mime-type, it includes formal patient-centric documents (CDA), clinical notes, scanned paper, non-patient specific documents like policy text, as well as a photo, video, or audio recording acquired or used in healthcare. The DocumentReference resource provides metadata about the document so that the document can be discovered and managed. The actual content may be inline base64 encoded data or provided by direct reference.",
        "URL": "https://hl7.org/fhir/DocumentReference.html"
    },
    {
        "Type": "Encounter",
        "Description": "An interaction between a patient and healthcare provider(s) for the purpose of providing healthcare service(s) or assessing the health status of a patient. Encounter is primarily used to record information about the actual activities that occurred, where Appointment is used to record planned activities.",
        "URL": "https://hl7.org/fhir/Encounter.html"
    },
    {
        "Type": "ExplanationOfBenefit",
        "Description": "This resource provides: the claim details; adjudication details from the processing of a Claim; and optionally account balance information, for informing the subscriber of the benefits provided.",
        "URL": "https://hl7.org/fhir/ExplanationOfBenefit.html"
    },
    {
        "Type": "Goal",
        "Description": "Describes the intended objective(s) for a patient, group or organization care, for example, weight loss, restoring an activity of daily living, obtaining herd immunity via immunization, meeting a process improvement objective, etc.",
        "URL": "https://hl7.org/fhir/Goal.html"
    },
    {
        "Type": "HealthcareService",
        "Description": "The details of a healthcare service available at a location.",
        "URL": "https://hl7.org/fhir/HealthcareService.html"
    },
    {
        "Type": "Immunization",
        "Description": "Describes the event of a patient being administered a vaccine or a record of an immunization as reported by a patient, a clinician or another party.",
        "URL": "https://hl7.org/fhir/Immunization.html"
    },
    {
        "Type": "InsurancePlan",
        "Description": "Details of a Health Insurance product/plan provided by an organization.",
        "URL": "https://hl7.org/fhir/InsurancePlan.html"
    },
    {
        "Type": "Location",
        "Description": "Details and position information for a place where services are provided and resources and participants may be stored, found, contained, or accommodated.",
        "URL": "https://hl7.org/fhir/Location.html"
    },
    {
        "Type": "MedicationAdministration",
        "Description": "Describes the event of a patient consuming or otherwise being administered a medication. This may be as simple as swallowing a tablet or it may be a long running infusion. Related resources tie this event to the authorizing prescription, and the specific encounter between patient and health care practitioner.",
        "URL": "https://hl7.org/fhir/MedicationAdministration.html"
    },
    {
        "Type": "MedicationDispense",
        "Description": "Indicates that a medication product is to be or has been dispensed for a named person/patient. This includes a description of the medication product (supply) provided and the instructions for administering the medication. The medication dispense is the result of a pharmacy system responding to a medication order.",
        "URL": "https://hl7.org/fhir/MedicationDispense.html"
    },
    {
        "Type": "MedicationKnowledge",
        "Description": "Information about a medication that is used to support knowledge.",
        "URL": "https://hl7.org/fhir/MedicationKnowledge.html"
    },
    {
        "Type": "MedicationRequest",
        "Description": "An order or request for both supply of the medication and the instructions for administration of the medication to a patient. The resource is called \"MedicationRequest\" rather than \"MedicationPrescription\" or \"MedicationOrder\" to generalize the use across inpatient and outpatient settings, including care plans, etc., and to harmonize with workflow patterns.",
        "URL": "https://hl7.org/fhir/MedicationRequest.html"
    },
    {
        "Type": "Observation",
        "Description": "Measurements and simple assertions made about a patient, device or other subject.",
        "URL": "https://hl7.org/fhir/Observation.html"
    },
    {
        "Type": "Organization",
        "Description": "A formally or informally recognized grouping of people or organizations formed for the purpose of achieving some form of collective action. Includes companies, institutions, corporations, departments, community groups, healthcare practice groups, payer/insurer, etc.",
        "URL": "https://hl7.org/fhir/Organization.html"
    },
    {
        "Type": "OrganizationAffiliation",
        "Description": "Defines an affiliation/association/relationship between 2 distinct organizations, that is not a part-of relationship/sub-division relationship.",
        "URL": "https://hl7.org/fhir/OrganizationAffiliation.html"
    },
    {
        "Type": "Patient",
        "Description": "Demographics and other administrative information about an individual or animal receiving care or other health-related services.",
        "URL": "https://hl7.org/fhir/Patient.html"
    },
    {
        "Type": "Practitioner",
        "Description": "A person who is directly or indirectly involved in the provisioning of healthcare or related services.",
        "URL": "https://hl7.org/fhir/Practitioner.html"
    },
    {
        "Type": "PractitionerRole",
        "Description": "A specific set of Roles/Locations/specialties/services that a practitioner may perform at an organization for a period of time.",
        "URL": "https://hl7.org/fhir/PractitionerRole.html"
    },
    {
        "Type": "Procedure",
        "Description": "An action that is or was performed on or for a patient, practitioner, device, organization, or location. For example, this can be a physical intervention on a patient like an operation, or less invasive like long term services, counseling, or hypnotherapy. This can be a quality or safety inspection for a location, organization, or device. This can be an accreditation procedure on a practitioner for licensing.",
        "URL": "https://hl7.org/fhir/Procedure.html"
    },
    {
        "Type": "Provenance",
        "Description": "Provenance of a resource is a record that describes entities and processes involved in producing and delivering or otherwise influencing that resource. Provenance provides a critical foundation for assessing authenticity, enabling trust, and allowing reproducibility. Provenance assertions are a form of contextual metadata and can themselves become important records with their own provenance. Provenance statement indicates clinical significance in terms of confidence in authenticity, reliability, and trustworthiness, integrity, and stage in lifecycle (e.g. Document Completion - has the artifact been legally authenticated), all of which may impact security, privacy, and trust policies.",
        "URL": "https://hl7.org/fhir/Provenance.html"
    },
    {
        "Type": "Questionnaire",
        "Description": "A structured set of questions intended to guide the collection of answers from end-users. Questionnaires provide detailed control over order, presentation, phraseology and grouping to allow coherent, consistent data collection.",
        "URL": "https://hl7.org/fhir/Questionnaire.html"
    },
    {
        "Type": "QuestionnaireResponse",
        "Description": "A structured set of questions and their answers. The questions are ordered and grouped into coherent subsets, corresponding to the structure of the grouping of the questionnaire being responded to.",
        "URL": "https://hl7.org/fhir/QuestionnaireResponse.html"
    },
    {
        "Type": "RelatedPerson",
        "Description": "Information about a person that is involved in a patient's health or the care for a patient, but who is not the target of healthcare, nor has a formal responsibility in the care process.",
        "URL": "https://hl7.org/fhir/RelatedPerson.html"
    },
    {
        "Type": "ServiceRequest",
        "Description": "A record of a request for service such as diagnostic investigations, treatments, or operations to be performed.",
        "URL": "https://hl7.org/fhir/ServiceRequest.html"
    },
    {
        "Type": "Specimen",
        "Description": "A sample to be used for analysis.",
        "URL": "https://hl7.org/fhir/specimen.html"
    }
]